export default __webpack_public_path__ + "static/media/calenderToday.5519af3a.svg";